import { render } from "./ListeProfil.vue?vue&type=template&id=4d4031b4&ts=true"
import script from "./ListeProfil.vue?vue&type=script&lang=ts"
export * from "./ListeProfil.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__